module.exports = __webpack_public_path__ + "static/bg-bottom.861297a4.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/bg-bottom.png
// module id = 306
// module chunks = 2